import React, {useEffect, useState} from 'react'
import '../css/investor.css'
import {useWeb3React} from "@web3-react/core";
import {Web3Provider} from "@ethersproject/providers";
import {getCampaignContract, getInvestedAmount, prettyPrintBigNumber} from "../utils";
import {InvestorCheckPage} from "./investor-check";
import {InvestorBuyPage} from "./investor-buy-page";


export function InvestorPage({walletAddress, language}) {
    const { active, account, library, connector, activate, setError, deactivate } = useWeb3React<Web3Provider>()
    const [invested, setInvested] = useState<string>()
    const [showBuyPage, setShowBuyPage] = useState(false)



    useEffect(() => {
        (async () => {
            try {
                const campaignContract = await getCampaignContract(library)
                const investedBN = await getInvestedAmount(campaignContract, account)
                setInvested(investedBN.isZero() ? '' : prettyPrintBigNumber(investedBN))
            } catch (e) {
                console.error(e)
            }

            // setPublicRoundActive(await campaignContract.publicRoundActive())
        })().then()
    }, [])


    if (invested === undefined )
        return <div></div>
    else if (invested === '' || showBuyPage)
        return <InvestorBuyPage language={language} showBackButton={invested !== ''} backHandler={() => setShowBuyPage(false)}/>
    else
        return <InvestorCheckPage language={language} buyHandler={() => setShowBuyPage(true)}/>
}

























// export function InvestorPage({language}) {
//     return (
//         <div className={'container'}>
//             <div className={'content'}>
//                 <div className={'content-container'}>
//                     <p className={'locked'}>{language === 'ru' ? 'токены фета заблокированы: ' : 'pheta tokens locked:'}<span className={'locked-value'}>990</span></p>
//                     <p className={'unlocked'}>{language === 'ru' ? 'токены фета разблокированы: ' : 'pheta tokens unlocked:'}<span className={'unlocked-value'}>10</span></p>
//                     <a className={'content-button'}>{language === 'ru' ? 'получить 10 токенов' : 'get 10 tokens'}</a>
//                 </div>
//             </div>
//             <div className={'container'}>
//                 <div className="button-more-container">
//                     <a className="button-more">{language === 'ru' ? 'купить больше' : 'buy more'}</a>
//                 </div>
//             </div>
//         </div>
//     )
// }
